import React, {useCallback, useRef, useState} from "react";
import { useTranslation } from "react-i18next";

import { FormInput } from "../../components/common/FormInput";
import { useFormStore } from "../../store/useFormStore";
import { LocationContent } from "../../components/common/LocationContent";

import {
        CAPITAL_LETTERS,
        NUMBERS,
        SPECIAL_CHARACTERS,
    } from "../../utils/variables";
import { DATA_COUNTRY } from "../../utils/data";
import { validateFieldLogin } from "../../utils/helperValidations";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";

const useDebounce = (callback, delay) => {
    const timeoutRef = useRef(null);

    return useCallback((...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);
};

export const ProviderSignupForm = ({
    today,
    handleShowModal,
    handleCodeSelect,
    contactCode,
    code,
    setContactCode,
    setLangLong
}) => {
    const { t } = useTranslation();

    const [isNewPassword, setIsNewPassword] = useState(false);
    const [isPassword, setIsPassword] = useState(false);
    const [referralSource, setReferralSource] = useState("choose-list");
    const [isOpen, setIsOpen] = useState(false);

    const { formLogin, setFormLogin, errorField, setErrorField } = useFormStore();

    const hearFromOptions = [
        {
            value: "Internet browsing",
            name: "Internet browsing",
            disabled: false
        },
        {
            value: "Friend recommendation",
            name: "Friend recommendation",
            disabled: false
        },
        {
            value: "Facebook",
            name: "Facebook",
            disabled: false
        },
        {
            value: "Our website",
            name: "Our website",
            disabled: false
        },
        {
            value: "Other",
            name: "text-other",
            disabled: false
        },
    ];

    const validateDate = (date) => {
        if (date && date.isValid()) {
            setErrorField({ ...errorField, dob: "" });

            const age = today.getFullYear() - date.year();

            if (age > 16) {
                setFormLogin({
                    ...formLogin,
                    dob: date.format('YYYY-MM-DD'),
                });
            } else {
                handleShowModal();
            }
        }
    };

    const debouncedValidateDate = useDebounce(validateDate, 500);

    const handleDateChange = (date) => {
        debouncedValidateDate(date);
    };

    const getLatLong = (latlong2, e, address) => {
        if (e instanceof Promise) {
            e.then(function (result) {
                setLangLong(result);

            });
        } else {
            setLangLong(e);
        }

        // Extract all relevant address components
        let city = '';
        let country = '';
        let zip = '';
        console.log(latlong2);
        latlong2.address_components.forEach((component) => {
            // Get city
            if (component.types.includes('locality')) {
                city = component.long_name;
            }
            if (component.types.includes('postal_code')) {
                zip = component.long_name;
            }

            // Get country
            if (component.types.includes('country')) {
                country = component.long_name;
            }

                setErrorField((prevErrorField) => ({
                    ...prevErrorField,
                    country: "",
                    address: "",
                    city: "",
                    zip: ""
                }));

                setFormLogin((prevFormLogin) => ({
                    ...prevFormLogin,
                    country: component.long_name,
                    address: latlong2.formatted_address,
                    city: city,
                    zip: zip
                }));

        });
    };

    const handleChange = (e) => validateLoginField(e);

    const validateLoginField = (e) =>
    {
        const { name, value } = e.target ? e.target : e;

        const error = validateFieldLogin(
            name,
            value,
            formLogin,
            t,
            handleShowModal
        );

        setErrorField((prevErrorField) => ({
            ...prevErrorField,
            [name]: error,
        }));

        setFormLogin((prevFormLogin) => ({
            ...prevFormLogin,
            [name]: value,
        }));
    };

    const handleSelect = (item) =>
    {
        if (item.value) {
            validateLoginField({ name: "hearAboutUs", value: item.value });
            setReferralSource(item.value);
            setIsOpen(false)
        }
    }


    const toggleDropdown = (e) =>
    {
        e.preventDefault();
        setIsOpen(!isOpen)
    };

    const handleOnBlurRefferal = (e) =>
    {
        // scehdule dropwown close after handleSelect is done
        setTimeout(() =>
        {
            toggleDropdown(e)
        }, 100);
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>

            <form>
                <FormInput
                    label={t("First and Last Name")}
                    type="text"
                    placeholder={t("text-type")}
                    name="first_last_name"
                    errorField={errorField}
                    onChange={handleChange}
                />
                <FormInput
                    label={t("Username") + "*"}
                    type="text"
                    placeholder={t("text-type")}
                    name="username"
                    errorField={errorField}
                    onChange={handleChange}
                />

                <div className="form_group" style={{
                    marginBottom: "0px"
                }}>
                    <label>{t("Date of birth") + "*"}</label>
                    <DatePicker
                        value={formLogin.dob ? dayjs(formLogin.dob) : null} // Convert to Day.js object
                        onChange={handleDateChange}
                        maxDate={dayjs(today)} // Convert `today` if it's not already a Day.js object
                        format="DD-MM-YYYY"
                        slotProps={{
                            textField: {
                                placeholder: t("text-type"),
                                error: !!errorField.dob, // Boolean for error state
                                helperText: errorField.dob, // Display error message
                                InputProps: {
                                    className: errorField.dob ? "bordererror" : "", // Apply error class if needed
                                },
                            },
                        }}
                        className="custom-date-picker"
                    />
                </div>

                <FormInput
                    label={t("email-address") + "*"}
                    type="email"
                    placeholder={t("text-type")}
                    name="email"
                    errorField={errorField}
                    onChange={handleChange}
                />

                <div className="form_group">
                    <label>{t("text-password") + "*"}</label>
                    <input
                        type={isPassword ? "text" : "password"}
                        placeholder=". . . . . . . . ."
                        name="password"
                        onChange={(e) => validateLoginField(e)}
                        className={errorField.password == "" ? "" : "bordererror"}
                    />
                    <div className="eyes">
                        <input
                            type={"checkbox"}
                      onClick={(e) => {
                                setIsPassword(!isPassword);
                            }}
                        />
                        <i></i>
                    </div>
                    {errorField.password || errorField.password ? (
                        <div className="password_rule errorfield signuppassword">
                            <p>
                                {t("password-bw-8-15-char")}
                          <br/>
                                {CAPITAL_LETTERS.test(formLogin.password)
                                    ? ""
                                    : t("- at least one uppercase letter")}
                          <br/>
                                {NUMBERS.test(formLogin.password)
                                    ? ""
                                    : t(t("- at least one number digit"))}
                          <br/>
                                {SPECIAL_CHARACTERS.test(formLogin.password)
                                    ? ""
                                    : t("- at least one special character -for example:  #, @, !")}
                            </p>
                        </div>
                    ) : (
                        ""
                    )}
                </div>

                <div className="form_group">
                    <label>{t("Repeat password") + "*"}</label>
                    <input
                        type={isNewPassword ? "text" : "password"}
                        placeholder=". . . . . . . . . . "
                        name="c_password"
                        onChange={(e) => validateLoginField(e)}
                        className={errorField.c_password == "" ? "" : "bordererror"}
                    />
                    <div className="eyes">
                        <input
                            type={"checkbox"}
                      onClick={(e) => {
                                setIsNewPassword(!isNewPassword);
                            }}
                        />
                        <i></i>
                    </div>
                    <span className="errorfield">{errorField.c_password}</span>
                </div>

                <div className="form_group">
                    <label>{t("Address")}</label>
                    <div className={errorField.address == "" ? "" : "bordererror"}>
                        <LocationContent let={getLatLong}/>
                    </div>
                    <span className="errorfield">{errorField.address}</span>
                </div>

                <div className="form_group">
                    <label>{t("Zip code")}</label>
                    <input
                        type="number"
                        placeholder={t("text-type")}
                        name="zip"
                        value={formLogin.zip}
                        onChange={(e) => validateLoginField(e)}
                        className={errorField.zip == "" ? "" : "bordererror"}
                    />
                    <span className="errorfield">{errorField.zip}</span>
                </div>
                <div className="form_group">
                    <label>{t("How did you hear about us?")}</label>
                    <div className="select-box">
                        <input type="button"
                        value={t(referralSource)}
                        onClick={(e) => toggleDropdown(e)}
                        className={`select-btn
                        ${(!errorField.hearAboutUs || errorField.hearAboutUs === "") ? "" : "bordererror"} 
                            `}
                        />
                        <i className="fas fa-chevron-down select-down"></i> 
                    </div>
                    {
                        isOpen && (
                            <ul className={
                                ` singup-select autocomplete-dropdown-container`
                            }>
                                {hearFromOptions.map((item, index) => (
                                    <li key={item.value}
                                        onClick={() => handleSelect(item)}
                                        className="suggestion-item suggestion-item--highlighted"
                                    >
                                        {t(item.name)}
                                    </li>
                                ))}
                            </ul>

                        )
                    }
                    <span className="errorfield">{errorField.hearAboutUs}</span>
                </div>
            </form>
        </LocalizationProvider>
    );
};
